import axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";

import { getApiBaseUrl } from "@/configs/environment.config";

const defaultConfig: AxiosRequestConfig = {
  baseURL: getApiBaseUrl(),
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
};

class ApiClient {
  private instance: AxiosInstance;

  constructor(config: AxiosRequestConfig = {}) {
    this.instance = axios.create({ ...defaultConfig, ...config });
    // Attach auth token automatically for browser requests
    this.instance.interceptors.request.use((request) => {
      if (typeof window !== "undefined") {
        const token = window.localStorage.getItem("access_token")?.trim();
        if (token && request.headers) {
          request.headers.set("Authorization", `Bearer ${token}`);
        }

        console.debug("[API] Request auth state", {
          method: request.method?.toUpperCase(),
          url: request.url,
          hasAccessToken: Boolean(token),
        });
      }

      return request;
    });

    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 && typeof window !== "undefined") {
          window.localStorage.removeItem("access_token");
          window.localStorage.removeItem("auth-store");
          if (window.location.pathname !== "/") {
            window.location.assign("/");
          }
        }

        return Promise.reject(error);
      },
    );
  }

  public getInstance() {
    return this.instance;
  }
}

export const apiClient = new ApiClient().getInstance();

export function createApiClient(config?: AxiosRequestConfig) {
  return new ApiClient(config).getInstance();
}
